var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCtaIconsGenerateLabels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.158,
    height: 14.027,
    viewBox: "0 0 15.158 14.027",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-39.056 -92.882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.643,211.45H40.627a1.571,1.571,0,0,0-1.571,1.571v6.154a1.571,1.571,0,0,0,1.571,1.571h2.047v-4.106H50.6v4.106h2.046a1.571,1.571,0,0,0,1.571-1.571v-6.154A1.571,1.571,0,0,0,52.643,211.45Zm-.972,3.1H50.409a.5.5,0,0,1,0-1h1.262a.5.5,0,1,1,0,1Z",
    transform: "translate(0 -116.423)",
    fill: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.937,93.389v2.38l.507-.507H211.52l.507.507v-2.38l-.507.507h7.923a.507.507,0,0,0,0-1.013h-7.924a.511.511,0,0,0-.507.507v2.38a.511.511,0,0,0,.507.507h7.923a.511.511,0,0,0,.507-.507v-2.38a.506.506,0,1,0-1.013,0Zm0,6.828V106.4l.507-.507H211.52l.507.507v-6.187l-.507.507h7.924a.507.507,0,0,0,0-1.013h-7.924a.511.511,0,0,0-.507.507V106.4a.511.511,0,0,0,.507.507h7.924a.511.511,0,0,0,.507-.507v-6.187a.506.506,0,1,0-1.013,0Z",
    transform: "translate(-168.846)",
    fill: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.78,587.229h3.066a.506.506,0,1,0,0-1.013H345.78a.506.506,0,1,0,0,1.013Zm0,1.985h2.149a.506.506,0,1,0,0-1.013H345.78a.506.506,0,1,0,0,1.013Z",
    transform: "translate(-300.679 -484.41)",
    fill: "#b4b4b4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaIconsGenerateLabels);
export default __webpack_public_path__ + "static/media/ctaIcons_GenerateLabels.a3bf0d5e.svg";
export { ForwardRef as ReactComponent };